import dynamic from 'next/dynamic'

export const DynamicRatingsAndReviewsInfoModal = dynamic(
  () => import('.').then((m) => m.RatingsAndReviewsInfoModal),
  { ssr: false },
)
